<div class="admin-dialog">
  <!-- Header -->
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left">
      <h2 class="admin-dialog__title" i18n="@@adminSectionGroup.sectionDetails.title.sectionInfo">セクション情報</h2>
    </div>
    <button mat-icon-button class="admin-dialog__close" (click)="onNoClick()" aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="admin-dialog__content">
    <form [formGroup]="sectionFormGroup" (ngSubmit)="submit()">

      @if (sectionId == null) {
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.assignAdmin">管理者・スタッフ・ユーザー割り当て</span>
          </div>

          <div class="role-checkboxes">
            <label class="role-checkbox">
              <mat-checkbox formControlName="makeMyselfAnAdmin" color="primary"></mat-checkbox>
              <span class="role-checkbox__label" i18n="@@adminSectionGroup.sectionDetails.label.makeMyselfAnAdmin">自分自身を新しいセクションの管理者にする</span>
            </label>
          </div>

          <!-- <mat-radio-group formControlName="assignAdmin" class="form-radio-group">
            @for (aa of assignAdmin; track aa.value) {
              <!-- assignNew かつ 選択中 の時だけ 'is-expanded' クラスを付与 --
              <div class="radio-item-container">
                
                <mat-radio-button [value]="aa.value" color="primary" class="custom-radio-btn">
                  {{ aa.desc }}
                </mat-radio-button>

              </div>
            }
          </mat-radio-group> -->
        </div>

        <div class="admin-dialog__divider"></div>

        <div class="admin-dialog__section">
          <div class="role-checkboxes">
            <label class="role-checkbox">
              <mat-checkbox formControlName="createNewStaff" color="primary"></mat-checkbox>
              <span class="role-checkbox__label" i18n="@@adminSectionGroup.sectionDetails.label.createNewStaff">新しいスタッフを作成する</span>
            </label>
          </div>
          @if (sectionFormGroup.get('createNewStaff')?.value) {
            <div class="admin-dialog__section">

              <div class="nested-fields-box">
                <!-- 入力フィールド群 -->
                <div class="form-label">
                  <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.staffInfo">スタッフの権限</span>
                </div>
                <div class="role-checkboxes">
                  <label class="role-checkbox">
                    <mat-checkbox formControlName="staffAccountManageRole" color="primary"></mat-checkbox>
                    <span class="role-checkbox__label" i18n="@@adminSection.staffInvitation.label.accountManagement">スタッフ管理</span>
                  </label>
                  <label class="role-checkbox">
                    <mat-checkbox formControlName="staffUserManageRole" color="primary"></mat-checkbox>
                    <span class="role-checkbox__label" i18n="@@adminSection.staffInvitation.label.userManagement">ユーザー管理</span>
                  </label>
                </div>

                <div></div>

                <div class="form-label">
                  <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.staffInfo">スタッフの情報</span>
                  <!-- <span class="form-label__required">*</span> -->
                </div>
                <div class="admin-dialog__field-row">
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.staffSignInName">サインイン名*</mat-label>
                    <input matInput formControlName="staffSignInName" />
                    @if (sectionFormGroup.get('staffSignInName')?.hasError('staffSignInNameRequired')){
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.staffEmailAddress">メールアドレス*</mat-label>
                    <input matInput formControlName="staffEmailAddress" />
                    @if (sectionFormGroup.get('staffEmailAddress')?.hasError('staffEmailAddressRequired')){
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                    }
                    @if (sectionFormGroup.get('staffEmailAddress')?.hasError('email')) {
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.emailFormatInvalid">メールアドレスのフォーマットが誤っています</mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="admin-dialog__field-row">
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.lastName">氏*</mat-label>
                    <input matInput formControlName="staffLastName" />
                    @if (sectionFormGroup.get('staffLastName')?.hasError('staffLastNameRequired')){
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.firstName">名*</mat-label>
                    <input matInput formControlName="staffFirstName" />
                    @if (sectionFormGroup.get('staffFirstName')?.hasError('staffFirstNameRequired')){
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                    }
                  </mat-form-field>
                </div>

                <!-- <div class="admin-dialog__field-row">
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.lastNameEN">姓(ローマ字)</mat-label>
                    <input matInput formControlName="staffLastNameEN" />
                    @if (sectionFormGroup.get('staffLastNameEN')?.hasError('staffLastNameRequired')){
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                    }
                    @if (sectionFormGroup.get('staffLastNameEN')?.hasError('pattern')){
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">英数字のみです</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.firstNameEN">名(ローマ字)</mat-label>
                    <input matInput formControlName="staffFirstNameEN" />
                    @if (sectionFormGroup.get('staffFirstNameEN')?.hasError('staffFirstNameRequired')){
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                    }
                    @if (sectionFormGroup.get('staffFirstNameEN')?.hasError('pattern')){
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">英数字のみです</mat-error>
                    }
                  </mat-form-field>
                </div> -->

                <div class="admin-dialog__field-row">
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.sex">性別</mat-label>
                    <mat-select formControlName="staffSex">
                      @for (sex of sexOptions; track sex.value) {
                        <mat-option [value]="sex.value">
                          {{ sex.viewValue }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                </div>
                <!-- <div class="role-checkboxes">
                  <label class="role-checkbox">
                    <mat-checkbox formControlName="staffSendNotificationEmail" color="primary"></mat-checkbox>
                    <span class="role-checkbox__label" i18n="@@adminSectionGroup.sectionDetails.label.staffSendNotificationEmail">セクション情報をメールで送信する</span>
                  </label>
                </div> -->
              </div>
            </div>
          }
        </div>

        <div class="admin-dialog__divider"></div>
        
        <div class="admin-dialog__section">
          <div class="role-checkboxes">
            <label class="role-checkbox">
              <mat-checkbox formControlName="createNewUser" color="primary"></mat-checkbox>
              <span class="role-checkbox__label" i18n="@@adminSectionGroup.sectionDetails.label.createNewUser">新しいユーザを作成する</span>
            </label>
          </div>
          @if (sectionFormGroup.get('createNewUser')?.value) {
            <div class="nested-fields-box">

              <div class="form-label">
                <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.userInfo">ユーザ情報</span>
                <!-- <span class="form-label__required">*</span> -->
              </div>

              <div class="admin-dialog__section">
                <mat-radio-group formControlName="userNameOrCode" class="form-radio-group">
                  @for (nc of userNameOrCode; track nc.value) {
                    <div class="radio-item-container">                      
                      <mat-radio-button [value]="nc.value" color="primary" class="custom-radio-btn">
                        {{ nc.desc }}
                      </mat-radio-button>
                    </div>
                  }
                </mat-radio-group>
              
                <div class="admin-dialog__field-row">
                  @if(sectionFormGroup.get('userNameOrCode')?.value == "name"){
                    <mat-form-field appearance="outline" class="form-field form-field--half">
                      <mat-label i18n="@@adminSectionGroup.sectionDetails.label.lastName">氏*</mat-label>
                      <input matInput formControlName="userLastName" />
                      @if (sectionFormGroup.get('userLastName')?.hasError('userLastNameRequired')){
                        <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                      }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="form-field form-field--half">
                      <mat-label i18n="@@adminSectionGroup.sectionDetails.label.firstName">名*</mat-label>
                      <input matInput formControlName="userFirstName" />
                      @if (sectionFormGroup.get('userFirstName')?.hasError('userFirstNameRequired')){
                        <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                      }
                    </mat-form-field>
                  }
                  @else{
                    <mat-form-field appearance="outline" class="form-field form-field--half">
                      <mat-label i18n="@@adminSectionGroup.sectionDetails.label.userCode">コード*</mat-label>
                      <input matInput formControlName="userCode" />
                      @if (sectionFormGroup.get('userCode')?.hasError('userCodeRequired')){
                        <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                      }
                    </mat-form-field>

                  }
                </div>

                <div class="admin-dialog__field-row">
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.userBirthDate">誕生日</mat-label>
                    <input matInput formControlName="userBirthDate" type="date"/>
                    <!-- @if (sectionFormGroup.get('city')?.hasError('required')) {
                      <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
                    } -->
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSectionGroup.sectionDetails.label.sex">性別</mat-label>
                    <mat-select formControlName="userSex">
                      @for (sex of sexOptions; track sex.value) {
                        <mat-option [value]="sex.value">
                          {{ sex.viewValue }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                </div>
              </div>

            </div>
          }
        </div>

        <div class="admin-dialog__divider"></div>
      }

      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.sectionName">セクション名</span>
          <span class="form-label__required">*</span>
        </div>
        <mat-form-field appearance="outline" class="form-field">
          <input matInput formControlName="sectionName" />
          <mat-icon matSuffix class="material-icons-outlined">apartment</mat-icon>
          @if (sectionFormGroup.get('sectionName')?.hasError('required')) {
            <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
          }
        </mat-form-field>

        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.description">説明</span>
        </div>
        <mat-form-field appearance="outline" class="form-field">
          <input matInput formControlName="description" />
        </mat-form-field>
      </div>

      @if (sectionId != null) {
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.id">ID</span>
          </div>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="id" />
            <mat-icon matSuffix class="material-icons-outlined">badge</mat-icon>
          </mat-form-field>
        </div>
      }

      <div class="admin-dialog__divider"></div>

      <!-- Address -->
      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text form-label__text--section" i18n="@@adminSectionGroup.sectionDetails.label.address">住所</span>
        </div>
        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.zipCode">郵便番号</mat-label>
            <input matInput formControlName="zip" />
            @if (sectionFormGroup.get('zip')?.hasError('required')) {
              <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.prefecture">県</mat-label>
            <input matInput formControlName="prefecture" />
            @if (sectionFormGroup.get('prefecture')?.hasError('required')) {
              <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.city">市区</mat-label>
            <input matInput formControlName="city" />
            @if (sectionFormGroup.get('city')?.hasError('required')) {
              <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.town">町村</mat-label>
            <input matInput formControlName="town" />
            @if (sectionFormGroup.get('town')?.hasError('required')) {
              <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.line1">番地</mat-label>
            <input matInput formControlName="line1" />
            @if (sectionFormGroup.get('line1')?.hasError('required')) {
              <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.line2">建物名・部屋番号</mat-label>
            <input matInput formControlName="line2" />
          </mat-form-field>
        </div>
      </div>

      <div class="admin-dialog__divider"></div>

      <!-- Contact -->
      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text form-label__text--section" i18n="@@adminSectionGroup.sectionDetails.label.contact">連絡先</span>
        </div>
        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.phone">電話番号</mat-label>
            <input matInput formControlName="phone" />
            <mat-icon matSuffix class="material-icons-outlined form-field__contact-icon">phone</mat-icon>
            @if (sectionFormGroup.get('phone')?.hasError('required')) {
              <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.mobile">携帯電話番号</mat-label>
            <input matInput formControlName="mobile" />
            <mat-icon matSuffix class="material-icons-outlined form-field__contact-icon">smartphone</mat-icon>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="form-field">
          <mat-label i18n="@@adminSectionGroup.sectionDetails.label.email">e-mail</mat-label>
          <input matInput formControlName="email" />
          <mat-icon matSuffix class="material-icons-outlined form-field__contact-icon">mail</mat-icon>
          @if (sectionFormGroup.get('email')?.hasError('required')) {
            <mat-error i18n="@@adminSectionGroup.sectionDetails.error.required">必須項目です</mat-error>
          }
          @if (sectionFormGroup.get('email')?.hasError('email')) {
            <mat-error i18n="@@adminSectionGroup.sectionDetails.error.emailFormatInvalid">メールアドレスのフォーマットが誤っています</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="admin-dialog__divider"></div>

      <!-- Quota Model -->
      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.quotaModel">データ使用料モデル</span>
        </div>
        <mat-radio-group formControlName="quotaModel" class="form-radio-group">
          @for (model of common.quotaModels; track model.code) {
            <mat-radio-button [value]="model.code" color="primary">{{ model.desc }}</mat-radio-button>
          }
        </mat-radio-group>
      </div>

      @if (this.sectionFormGroup.value.quotaModel == 'DEDICATED') {
        <div class="admin-dialog__section">
          <div class="form-label form-label--small">
            <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.monthlyQuotaGB">一か月のデータ使用料上限</span>
          </div>
          <mat-form-field appearance="outline" class="form-field form-field--date">
            <input matInput formControlName="monthlyQuotaGB" type="number" min="0" max="100" />
            <span matTextSuffix class="form-field__unit-suffix">GB</span>
          </mat-form-field>
        </div>
      }

      @if (sectionId != null) {
        <div class="admin-dialog__divider"></div>

        <!-- Contract (read-only, only shown for existing sections) -->
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text form-label__text--section" i18n="@@adminSectionGroup.sectionDetails.label.contract">契約</span>
          </div>
          <div class="admin-dialog__field-row">
            <mat-form-field appearance="outline" class="form-field form-field--third">
              <mat-label i18n="@@adminSectionGroup.sectionDetails.label.contractStartAt">開始日</mat-label>
              <input matInput formControlName="contractStartAt" />
              <mat-icon matSuffix class="material-icons-outlined">calendar_today</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field form-field--third">
              <mat-label i18n="@@adminSectionGroup.sectionDetails.label.contractEndAt">終了日</mat-label>
              <input matInput formControlName="contractEndAt" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field form-field--third">
            <mat-label i18n="@@adminSectionGroup.sectionDetails.label.contractStatus">ステータス</mat-label>
            <mat-select formControlName="contractStatus">
              @for (status of contractStatus; track status.value) {
                <mat-option [value]="status.value">
                  {{ status.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          </div>
        </div>
      }

      @if (sectionId != null) {
        <div class="admin-dialog__divider"></div>
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSectionGroup.sectionDetails.label.admins">管理者</span>
          </div>
          <select multiple id="adminSelect" class="legacy-select legacy-select--multi">
            @for (admin of admins; track admin.id) {
              <option [value]="admin.user.id">
                {{ admin.user.firstName }} {{ admin.user.lastName }}
              </option>
            }
          </select>
          <div class="admin-action-row">
            <button mat-stroked-button type="button" (click)="inviteAdmin()">
              <mat-icon>send</mat-icon>
              <span i18n="@@adminSectionGroup.sectionDetails.button.inviteAdmin">管理者招待</span>
            </button>
          </div>
        </div>
      }

    </form>
  </div>

  <!-- Footer -->
  <div class="admin-dialog__footer">
    @if (!changesMade) {
      <button mat-stroked-button (click)="onNoClick()">
        <span i18n="@@adminSectionGroup.sectionDetails.button.close">閉じる</span>
      </button>
    } @else {
      <button mat-stroked-button color="warn" (click)="onNoClick()">
        <span i18n="@@adminSectionGroup.sectionDetails.button.discard">破棄</span>
      </button>
    }
    @if (hasSectionManagement) {
      @if (mode === Mode.disp) {
        <button mat-flat-button
                type="button"
                color="primary"
                (click)="onEditClicked()">
          <mat-icon>edit</mat-icon>
          <span i18n="@@adminSectionGroup.sectionDetails.button.edit">編集</span>
        </button>
      } @else {
        <button mat-flat-button
                type="button"
                color="primary"
                [disabled]="isSending()"
                (click)="onUploadClicked()">
          @if (isSending()) {
            <mat-spinner diameter="18"></mat-spinner>
          } @else {
            <mat-icon>send</mat-icon> 
          }
          <span i18n="@@adminSectionGroup.sectionDetails.button.save">保存</span>
        </button>
      }
    }
    @if (sectionId != null && isStaffOfSection) {
      <button mat-stroked-button (click)="openNewWindow('/section-admin/' + sectionId)">
        <mat-icon>open_in_new</mat-icon>
        <span i18n="@@adminSectionGroup.sectionDetails.button.adminPage">管理ページ</span>
      </button>
    }
  </div>
</div>
